<template>
  <div class="myHome">
    <div class="myHome-box">
      <div class="myHeard" @click="toSign">
        <div class="img" v-if="!my.mobile">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="img" v-if="my.mobile">
          <img :src="my.head" alt />
        </div>
        <div class="toLogin">{{ my.mobile ? my.name : "去登陆" }}</div>
      </div>
      <div class="myList">
        <div class="myitem" @click="toVip">
          <div class="left">
            <img src="../../../assets/img/h5/wdVip.png" alt />会员申请
          </div>
          <div class="right">
            <img src="../../../assets/img/h5/more.png" alt />
          </div>
        </div>
        <div class="myitem" @click="toSign">
          <div class="left leftSvg">
            <img src="../../../assets/img/h5/set.svg" alt /> 修改资料
          </div>
          <div class="right">
            <img src="../../../assets/img/h5/more.png" alt />
          </div>
        </div>
        <div class="myitem" @click="toabout">
          <div class="left">
            <img src="../../../assets/img/h5/wd.png" alt /> 关于我们
          </div>
          <div class="right">
            <img src="../../../assets/img/h5/more.png" alt />
          </div>
        </div>
      </div>
    </div>
    <Nav type="my" />
  </div>
</template>

<script>
import Nav from "@/components/h5/base/nav.vue"; // 关于我们

export default {
  data() {
    return {
      my: {
        name: "",
        head: "",
        id: ""
      }
    };
  },
  components: {
    Nav
  },
  created() {
    const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
    this.my = {
      name: ListObj.name,
      head: ListObj.head,
      id: ListObj.id,
      mobile: ListObj.mobile
    };
  },
  methods: {
    toSign() {
      if (!this.my.mobile) {
        this.$router.push({ name: "H5sign" });
      } else {
        this.$router.push({ name: "H5myData" });
      }
    },
    // toSetMydata() {
    //   if (!this.my.mobile) {
    //     return;
    //   }
    //   this.$router.push({ name: "H5myData" });
    // },
    toVip() {
      if (this.my.id !== "") {
        this.$router.push({ name: "H5vipLink" });
      } else {
        this.$router.push({ name: "H5sign" });
      }
    },
    toabout() {
      this.$router.push({ name: "H5myAbout" });
    }
  }
};
</script>

<style lang="less">
.myHome {
  width: 100vw;
  height: 100vh;
  .myHome-box {
    height: calc(100vh - 56px);
    overflow-y: auto;
    .myHeard {
      display: flex;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;
      width: 100%;
      height: 160px;
      background: #165194;
      .img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 66px;
        height: 66px;
        border-radius: 50%;
        background: #e7ecf0;
        overflow: hidden;
        i {
          font-size: 40px;
          color: #ffffff;
        }
      }
      .toLogin {
        margin-left: 10px;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .myList {
      padding: 0 16px;
      box-sizing: border-box;
      .myitem {
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin: 10px 0;
        padding: 10px 0;
        border-bottom: 1px solid #e6e6e6;
        .left {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #343434;
          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .leftSvg {
          img {
            width: 28px;
            height: 28px;
            font-weight: bold;
            margin-right: 6px;
            margin-left: -4px;
          }
        }
        .right {
          img {
            width: 14px;
          }
        }
      }
    }
  }
}
</style>
